import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MediaPlayer } from "./ExerciseMedia";

const byName = (lib, e) => (lib || []).find((x) => x.name.trim().toLowerCase() === (e.name || "").trim().toLowerCase());

export const findDemo = (lib, e) =>
  (e.exercise_id && (lib || []).find((x) => x.id === e.exercise_id)) || byName(lib, e);

export default function DemoDialog({ exercise, onClose }) {
  return (
    <Dialog open={!!exercise} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto bg-[#0B1220] border-[#1E293B]" data-testid="demo-dialog">
        {exercise && (<>
          <DialogHeader><DialogTitle className="font-display uppercase text-2xl" data-testid="demo-dialog-title">{exercise.name}</DialogTitle></DialogHeader>
          <MediaPlayer media={exercise.media} imageUrl={exercise.image_url} />
          <div className="text-xs text-slate-300">Primary muscle: {exercise.primary_muscle || exercise.muscle_group || "Not specified"}</div>
          {!!exercise.secondary_muscles?.length && <div className="text-xs text-slate-400">Secondary muscles: {exercise.secondary_muscles.map((item) => item.name).join(" · ")}</div>}
          {!!exercise.equipment_items?.length && <div className="text-xs text-slate-400">Equipment: {exercise.equipment_items.map((item) => item.name).join(" · ")}</div>}
          {!!exercise.exercise_categories?.length && <div className="text-xs text-slate-400">Categories: {exercise.exercise_categories.map((item) => item.name).join(" · ")}</div>}
          {exercise.instructions && <p className="text-sm text-slate-300 whitespace-pre-wrap" data-testid="demo-dialog-instructions">{exercise.instructions}</p>}
        </>)}
      </DialogContent>
    </Dialog>
  );
}
